/**
 * 取引先名称の完全一致重複判定 (spec AC-OMT-020)。
 *
 * 「同一グループの複数拠点等の意図的な同名登録シナリオ」 を許容する soft
 * warning のため、 判定自体はここでは真偽値のみ返す (= hard reject しない)。
 * Edit モードは `excludeId` で自身の行を判定対象から除外する (= 自己一致で
 * 誤警告しない)。
 */
export function isDuplicateTradingPartnerName(
  items: ReadonlyArray<{ id: string; name: string }>,
  name: string,
  excludeId?: string,
): boolean {
  return items.some((item) => item.id !== excludeId && item.name === name)
}
